module.exports = __webpack_public_path__ + "static/media/file-csv.5f7def5e.svg";